import PropTypes from 'prop-types'
import React, { Component } from 'react'

import WordlistTable from './WordlistTable'
import intersectionWith from 'lodash/intersectionWith'
import update from 'immutability-helper'
import without from 'lodash/without'

class WordlistEditor extends Component {
  static propTypes = {
    availableLanguages: PropTypes.array.isRequired,
    languages: PropTypes.array.isRequired,
    defaultLanguageId: PropTypes.string.isRequired,
    entries: PropTypes.array.isRequired,
    allEntries: PropTypes.array.isRequired,
    totalEntries: PropTypes.number.isRequired,
    searchQuery: PropTypes.string,
    userIsLoggedIn: PropTypes.bool,
    myLists: PropTypes.array,
    selectedList: PropTypes.string,
    onSearchQueryInputChange: PropTypes.func,
    onShowLanguagePickerButtonClick: PropTypes.func,
    onLanguageCheckboxChange: PropTypes.func,
    onLoadMoreButtonClick: PropTypes.func,
    onEntrySpeakClick: PropTypes.func,
    showLanguagePicker: PropTypes.bool,
    onEditorFormSubmit: PropTypes.func,
    onEditorFormCancel: PropTypes.func,
    saving: PropTypes.bool,
  }
  state = {
    list: {
      id: null,
      name: '',
      entryIds: [],
    },
    showValidationErrors: false,
  }

  constructor(props) {
    super(props)
    let { myLists, selectedList, mode } = props
    if (mode === 'edit') {
      let list = myLists.find(
        list => list.id === selectedList,
      )
      if (list) {
        this.state = update(this.state, {
          list: { $set: list },
        })
      }
    }
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.mode !== newProps.mode &&
      newProps.mode === 'create'
    ) {
      this.setState({
        list: {
          id: null,
          name: '',
          entryIds: [],
        },
      })
    }
  }

  handleEntryCheckboxChange = event => {
    let entryId = event.target.value
    let action
    if (this.state.list.entryIds.includes(entryId)) {
      action = entryIds => without(entryIds, entryId)
    } else {
      action = entryIds => entryIds.concat([entryId])
    }
    this.setState(state =>
      update(state, {
        list: {
          entryIds: { $apply: action },
        },
      }),
    )
  }

  handleNameInputChange = event => {
    let value = event.target.value
    this.setState(state =>
      update(state, {
        list: {
          name: { $set: value },
        },
      }),
    )
  }

  handleFormSubmit = event => {
    event.preventDefault()
    if (Object.keys(this.validationErrors()).length === 0) {
      this.setState({ showValidationErrors: false })
      this.props.onEditorFormSubmit(this.state.list)
    } else {
      this.setState({ showValidationErrors: true })
    }
  }

  validationErrors = () => {
    let {
      languages,
      defaultLanguageId,
      allEntries,
    } = this.props
    const errors = {}
    let { list: { name, entryIds } } = this.state
    if (!name) {
      errors.name = 'Ange ett namn'
    }
    let selectedEntries = intersectionWith(
      allEntries,
      entryIds || [],
      (entry, selectedEntry) => entry.id === selectedEntry,
    )
    let selectedLanguages = languages.filter(
      language => language.id !== defaultLanguageId,
    )
    if (selectedEntries.length === 0) {
      errors.selectedEntries =
        'Välj minst ett ord i tabellen'
    }
    if (selectedLanguages.length === 0) {
      errors.selectedLanguages =
        'Välj minst ett språk i rutan ovanför tabellen'
    }
    return errors
  }

  render() {
    let {
      // mode,
      languages,
      availableLanguages,
      defaultLanguageId,
      entries,
      allEntries,
      totalEntries,
      searchQuery = '',
      userIsLoggedIn,
      onSearchQueryInputChange,
      onShowLanguagePickerButtonClick,
      onLanguageCheckboxChange,
      onLoadMoreButtonClick,
      onEntrySpeakClick,
      showLanguagePicker = false,
      onEditorFormCancel,
      saving,
    } = this.props
    let {
      list: { name, entryIds },
      showValidationErrors,
    } = this.state
    let tableProps = {
      selectableEntries: true,
      languages,
      availableLanguages,
      defaultLanguageId,
      entries,
      selectedEntries: entryIds,
      totalEntries,
      searchQuery,
      onSearchQueryInputChange,
      onShowLanguagePickerButtonClick,
      onLanguageCheckboxChange,
      onEntryCheckboxChange: this.handleEntryCheckboxChange,
      onLoadMoreButtonClick,
      onEntrySpeakClick,
      showLanguagePicker,
    }
    let selectedEntries = intersectionWith(
      allEntries,
      entryIds || [],
      (entry, selectedEntry) => entry.id === selectedEntry,
    )
    let selectedLanguages = languages.filter(
      language => language.id !== defaultLanguageId,
    )
    let validationErrors = this.validationErrors()
    if (!userIsLoggedIn) {
      return (
        <div className="text-gray-500 italic center py-3">
          {'Logga in för att skapa egna listor'}
        </div>
      )
    }
    return (
      <div>
        <div className="grid grid-cols-12 mxn1">
          <div className="col-span-8 px-2">
            <WordlistTable {...tableProps} />
          </div>
          <div className="col-span-4 border-box px-2">
            <div className="bg-gray-50 px-2 py-2">
              <form onSubmit={this.handleFormSubmit}>
                <div className="py-2">
                  <label
                    className="font-bold"
                    htmlFor="wordlist-editor-field-name"
                  >
                    {'Namn:'}
                  </label>
                  <input
                    id="wordlist-editor-field-name"
                    className="pl-2 font-medium bg-white border text-pv-green-dark border-pv-green-dark w-full h-[40px]"
                    name="name"
                    type="text"
                    value={name}
                    onChange={this.handleNameInputChange}
                    required
                  />
                </div>
                <div className="py-2">
                  <label className="font-bold">{'Valda ord:'}</label>
                  {selectedEntries.length ? (
                    <ul className="list-disc list-inside mt-0 mb-0">
                      {selectedEntries.map(entry => {
                        return (
                          <li
                            key={
                              entry.values[
                                defaultLanguageId
                              ].value
                            }
                          >
                            {
                              entry.values[
                                defaultLanguageId
                              ].value
                            }
                          </li>
                        )
                      })}
                    </ul>
                  ) : (
                    <p
                      className={
                        showValidationErrors &&
                        validationErrors.selectedEntries
                          ? 'text-red-500 font-bold'
                          : 'text-gray-500 italic'
                      }
                    >
                      {(showValidationErrors &&
                        validationErrors.selectedEntries) ||
                        'Välj ord i tabellen'}
                    </p>
                  )}
                </div>
                <div className="py-2">
                  <label className="font-bold">
                    {'Valda språk:'}
                  </label>
                  {selectedLanguages.length ? (
                    <ul className="list-disc list-inside mt-0 mb-0">
                      {selectedLanguages.map(language => {
                        return (
                          <li key={language.label}>
                            {language.label}
                          </li>
                        )
                      })}
                    </ul>
                  ) : (
                    <span
                      className={
                        showValidationErrors &&
                        validationErrors.selectedLanguages
                          ? 'text-red-500 font-bold'
                          : 'text-gray-500 italic'
                      }
                    >
                      {(showValidationErrors &&
                        validationErrors.selectedLanguages) ||
                        'Välj språk ovanför tabellen'}
                    </span>
                  )}
                </div>
                <div className="py-2 flex mrn1">
                  <button
                    type="button"
                    className="flex-auto btn-white mr-1"
                    onClick={onEditorFormCancel}
                  >
                    {'Avbryt'}
                  </button>
                  <button
                    type="submit"
                    className="flex-auto btn-green mr-1"
                    disabled={saving}
                  >
                    {saving ? 'Sparar…' : 'Spara'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WordlistEditor
